export default __webpack_public_path__ + "static/media/@silviarossoficial.67cfac9e.webp";